import {
  UPDATE_SCHOOLCLASS,
  ADD_SCHOOLCLASS_VIDEO,
  REMOVE_SCHOOLCLASS_VIDEO,
  ADD_SCHOOLCLASS_PHOTO,
  REMOVE_SCHOOLCLASS_PHOTO,
  SET_GROUP_ID,
} from './types';
import apiCall from '../components/apiCall';

/**
 *
 * @return {Function}
 */
const updateSchoolClass = schoolClass => dispatch => {
  dispatch({ type: UPDATE_SCHOOLCLASS, payload: schoolClass });
};

const setGroupId = groupId => dispatch => {
  dispatch({ type: SET_GROUP_ID, payload: groupId });
};

const addVideo = (schoolClassId, video) => dispatch => {
  apiCall(`/schoolClass/${schoolClassId}/addVideo`, video, 'POST')
    .then((result) => {
      dispatch({ type: ADD_SCHOOLCLASS_VIDEO, payload: result });
    });
};

const removeVideo = videoId => dispatch => {
  apiCall(`/schoolClass/removeVideo/${videoId}`, {}, 'DELETE')
    .then((result) => {
      dispatch({ type: REMOVE_SCHOOLCLASS_VIDEO, payload: result });
    });
};

const addPhoto = (schoolClassId, photo) => dispatch => {
  apiCall(`/schoolClass/${schoolClassId}/addPhoto`, photo, 'POST')
    .then((result) => {
      dispatch({ type: ADD_SCHOOLCLASS_PHOTO, payload: result });
    });
};

const removePhoto = photoId => dispatch => {
  apiCall(`/schoolClass/removePhoto/${photoId}`, {}, 'DELETE')
    .then((result) => {
      dispatch({ type: REMOVE_SCHOOLCLASS_PHOTO, payload: result });
    });
};

const pauseTimer = timerPausedAt => (dispatch, getState) => {
  const { schoolClass } = getState();
  apiCall(`/schoolClass/${schoolClass.id}/setTimer`, { timerPausedAt }, 'PUT');
};

const emptyTimer = () => (dispatch, getState) => {
  const { schoolClass } = getState();
  apiCall(`/schoolClass/${schoolClass.id}/setTimer`, { timerPausedAt: null, timerEndsAt: null }, 'PUT');
};

const setTimer = timerEndsAt => (dispatch, getState) => {
  const { schoolClass } = getState();
  apiCall(`/schoolClass/${schoolClass.id}/setTimer`, { timerEndsAt, timerPausedAt: null }, 'PUT');
};

export default {
  updateSchoolClass,
  setGroupId,
  addVideo,
  removeVideo,
  addPhoto,
  removePhoto,
  pauseTimer,
  emptyTimer,
  setTimer,
};



// WEBPACK FOOTER //
// ./src/actions/schoolClass.js